<div class="segment-container">
  <div class="polygon {{status}}" [ngClass]="{ 'first': first, 'last': last }">
    <mat-icon [class.clickable]='clickable'>{{icon}}</mat-icon>
  </div>

  <mat-icon *ngIf="showWarning" class="warning-icon" color="warn">warning</mat-icon>
</div>
